var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9526 11.29C11.7702 11.1025 11.5227 10.9972 11.2647 10.9972C11.0067 10.9972 10.7593 11.1025 10.5768 11.29L8.77295 13.1427L8.75674 1C8.75674 0.734783 8.65423 0.480429 8.47176 0.292893C8.28929 0.105357 8.04181 0 7.78376 0V0C7.52571 0 7.27823 0.105357 7.09577 0.292893C6.9133 0.480429 6.81079 0.734783 6.81079 1L6.82571 13.1333L5.03349 11.29C4.84999 11.1078 4.60421 11.007 4.3491 11.0093C4.09399 11.0116 3.84996 11.1168 3.66956 11.3022C3.48916 11.4876 3.38684 11.7384 3.38462 12.0006C3.3824 12.2628 3.48047 12.5154 3.65771 12.704L6.19976 15.3167C6.6255 15.7541 7.20285 15.9998 7.80484 15.9998C8.40684 15.9998 8.98419 15.7541 9.40992 15.3167L11.9526 12.704C12.135 12.5165 12.2375 12.2622 12.2375 11.997C12.2375 11.7318 12.135 11.4775 11.9526 11.29Z",
    fill: "#182444"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_567_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0474 4.71C12.2298 4.89748 12.4773 5.00279 12.7353 5.00279C12.9933 5.00279 13.2407 4.89748 13.4232 4.71L15.227 2.85734L15.2433 15C15.2433 15.2652 15.3458 15.5196 15.5282 15.7071C15.7107 15.8946 15.9582 16 16.2162 16V16C16.4743 16 16.7218 15.8946 16.9042 15.7071C17.0867 15.5196 17.1892 15.2652 17.1892 15L17.1743 2.86667L18.9665 4.71C19.15 4.89216 19.3958 4.99296 19.6509 4.99068C19.906 4.9884 20.15 4.88323 20.3304 4.69782C20.5108 4.51241 20.6132 4.2616 20.6154 3.99941C20.6176 3.73721 20.5195 3.48461 20.3423 3.296L17.8002 0.683338C17.3745 0.245906 16.7972 0.000170549 16.1952 0.000170549C15.5932 0.000170549 15.0158 0.245906 14.5901 0.683338L12.0474 3.296C11.865 3.48353 11.7625 3.73784 11.7625 4.003C11.7625 4.26817 11.865 4.52248 12.0474 4.71Z",
    fill: "#182444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5676,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_567_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5676,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdown);
export default __webpack_public_path__ + "static/media/updown.38e53acfeef9b8a6fee448af9648c862.svg";
export { ForwardRef as ReactComponent };